export default __webpack_public_path__ + "static/media/582.5d0672d3.gif";